"use client"

import Script from "next/script";


const UmengAnalytics = ({ UM_MEASUREMENT_ID }: { UM_MEASUREMENT_ID: string }) => {
  if (!UM_MEASUREMENT_ID) {
    return null;
  }

  return (
    <Script id="umeng-analytics" strategy="afterInteractive">
      {
        `
var _czc = _czc || [];
(function () {
	var um = document.createElement("script");
	um.src = "https://v1.cnzz.com/z.js?id=${UM_MEASUREMENT_ID}&async=1";
	var s = document.getElementsByTagName("script")[0];
	s.parentNode.insertBefore(um, s);
})();
`
      }
    </Script>
  );
};

export default UmengAnalytics;
